import '../App.css';
import { useField } from 'formik';
import { TextField } from '@mui/material';

const CampoDeTexto = ({
    name,
    ...otrosProps
}) => {

    const [campo, datos] = useField(name);

    const configDelCampo = {
        ...campo,
        ...otrosProps,
        variant: "filled",
    };

    if (datos && datos.touched && datos.error) {
        configDelCampo.error = true;
        configDelCampo.helperText = datos.error;
    }

    return(
        <TextField className='campo-de-texto' color='secondary' {...configDelCampo}></TextField>
    );



};

export default CampoDeTexto;